import { Button, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as AccessibilityIcon } from 'assets/icons/accessibility.svg';
import { useTranslation } from 'react-i18next';

export const AccessibilityCheckPrompt = ({ onSetAccessibilityView }: { onSetAccessibilityView: () => void }) => {
  const { t } = useTranslation('common_navbar');
  const testId = 'accessibility-check-prompt-button';

  return (
    <Flex flexDir='row' borderRadius='base' py={3} px={6} bg='blackAlpha.200' w='100%' justifyContent={'space-between'}>
      <Flex flexDir='row' color={'font.500'} placeItems={'center'}>
        <AccessibilityIcon width={'16'} height={'16'} stroke='#2B2B35' color='#2B2B35' strokeWidth={'0.1'} />
        <Text ml={2} fontSize='sm' fontWeight='medium'>
          {t('modals.download.accessibility-prompt-header')}
        </Text>
      </Flex>
      <Button
        size='xs'
        w='fit-content'
        h={'7'}
        p={2}
        variant='transparent-outline'
        onClick={onSetAccessibilityView}
        data-testid={testId}
        color='font.500'
        fontWeight={'medium'}
        whiteSpace='pre-wrap'
      >
        {t('modals.download.accessibility-prompt-button')}
      </Button>
    </Flex>
  );
};
